import { ping } from '@bedrock-rdk/utils';
import { L_BANNER_WIDTH_SCALE, L_BANNER_HEIGHT_SCALE, L_BANNER_SAFEGUARD_PERIOD } from './lBanner.constants';
import { SCREEN_HEIGHT, SCREEN_WIDTH, getScreenSize } from '../../tornado/utils/sizes';

export const getLBannerWidth = () => {
  const screenSize = getScreenSize();

  return Math.floor(SCREEN_WIDTH[screenSize] * L_BANNER_WIDTH_SCALE);
};

export const getLBannerHeight = () => {
  const screenSize = getScreenSize();

  return Math.floor(SCREEN_HEIGHT[screenSize] * L_BANNER_HEIGHT_SCALE);
};

export const getLBannerWidthScale = () => L_BANNER_WIDTH_SCALE;

export const getLBannerHeightScale = () => L_BANNER_HEIGHT_SCALE;

export const fetchTrackers = manifest => {
  try {
    return Array.from(manifest.querySelectorAll('Impression'))
      .map(node => node.textContent)
      .filter(Boolean);
  } catch (error) {
    return [];
  }
};

export const track = urls => (urls ? urls.map(url => ping(url)) : []);

export const validateCuePoints = (cuePoints, adCuePoints) => {
  if (!cuePoints.length) {
    return [];
  }

  return cuePoints.filter(cuePoint =>
    adCuePoints.every(adCuePoint => Math.abs(adCuePoint - cuePoint) > L_BANNER_SAFEGUARD_PERIOD),
  );
};
